import {
  ActivityDataWithType,
  ActivityRendererProps,
  ActivityRendererType,
  ActivityType,
} from "./types";
import { Column } from "../containers";
import { usePopupStore, useThemeStore } from "../../stores";
import { AlignItems, JustifyContent } from "../containers/types";
import CustomerActivityRenderer from "./customer-activity";
import ActivityPopupRenderer from "./ActivityPopupRenderer";
import Container, { EmptyContainer } from "../meta-container";
import FactorActivityRenderer from "./factor-activity";
import ChequeActivityRenderer from "./cheque-activity";
import CashActivityRenderer from "./cash-activity";

const ActivityRenderer = <T extends {}>({
  activity,
  type,
  back,
}: ActivityRendererProps<T>) => {
  const theme = useThemeStore((state) => state.theme);
  const setPopupBody = usePopupStore((state) => state.setPopupBody);
  const setPopupProperties = usePopupStore((state) => state.setPopupProperties);

  const onContainerClick = (): void => {
    setPopupProperties({
      style: { maxWidth: 816 },
    });
    setPopupBody(<ActivityPopupRenderer back={back} activity={activity} />);
  };

  return (
    <Column
      background={
        type === ActivityRendererType.Big ? theme.overlay : theme.background
      }
      style={styles.container}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Between}
      className="cursor-pointer"
      props={{ onClick: onContainerClick }}
    >
      <Container<ActivityType, ActivityDataWithType>
        data={{
          type,
          activity: activity.data,
          by: activity.by,
          date: activity.date,
        }}
        type={activity.type}
        match={{
          [ActivityType.None]: EmptyContainer,
          [ActivityType.Customer]: CustomerActivityRenderer,
          [ActivityType.Cheque]: ChequeActivityRenderer,
          [ActivityType.Factor]: FactorActivityRenderer,
          [ActivityType.Cash]: CashActivityRenderer,
        }}
      />
    </Column>
  );
};

export default ActivityRenderer;

const styles: Record<string, React.CSSProperties> = {
  container: {
    width: 145,
    height: 245,
    borderRadius: 15,
  },
};
